import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
	BaseCustomRequisitionModal,
	INewCustomRequisitionModalData,
} from '../base-custom-requisition-modal';
import { CustomRequisitionPrecedent } from '@models/requisitions';
import { SnackbarService } from '@services/ui/snackbar.service';
import { BusinessRequisitionsDispatch } from '@state/business/requisition/business_requisitions.dispatch';

@Component({
	selector: 'app-confirm-delete-custom-requisition',
	templateUrl: './confirm-delete-custom-requisition.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ConfirmDeleteCustomRequisitionComponent extends BaseCustomRequisitionModal {
	customRequisition: CustomRequisitionPrecedent;
	successMessage = 'Custom Requisition Template Deleted Successfully';
	errorMessage = 'Error deleting custom requisition';
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: INewCustomRequisitionModalData,
		protected dialogRef: MatDialogRef<
			ConfirmDeleteCustomRequisitionComponent,
			string
		>,
		protected businessRequisitionDispatch: BusinessRequisitionsDispatch,
		protected snackbarService: SnackbarService,
	) {
		super(data, dialogRef, businessRequisitionDispatch, snackbarService);
		this.customRequisition = {
			id: data.selectedRequisitionId,
		} as CustomRequisitionPrecedent;
	}

	onSubmitAction(requisition: CustomRequisitionPrecedent) {
		this.businessRequisitionDispatch.Remove(requisition.id);
		return requisition;
	}
}
